export default {"src":"/_next/static/media/twitter-icon.bc55fc80.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};